import React, {useState} from "react";
import MessageList from "../messageList/MessageList";
import { useParams } from "react-router-dom";
import "./PatientMessages.css";

const PatientMessages = ({ permitions, isCompanyAdmin, isSuperAdmin }) => {
  let { id } = useParams();
  const [isLoadedMessages, setIsLoadedMessages] = useState(false);
  
  const isMessagesLoaded = (val) => {
    setIsLoadedMessages(val);
  };
  
  
  return (
    <div className="patient_list_container patient_messages_container">
      <div className="title_divider">
        <div className="message_title_container">
          <div className="title_progress message_title">Messages</div>
        </div>
      </div>
      <div className="message_content_container">
        <MessageList
          userMessageList={id}
          fromPatientDetails={true}
          permitions={permitions}
          isCompanyAdmin={isCompanyAdmin}
          isSuperAdmin={isSuperAdmin}
		  isMessagesLoaded={isMessagesLoaded}
        />
      </div>
    </div>
  );
};

export default PatientMessages;
